import { Component, OnInit, ViewChild, AfterViewInit, Input } from '@angular/core';
import { GridComponent } from '../../../core/shared/grid/grid.component';
import { Router, ActivatedRoute } from '@angular/router';
import { LoginRest } from '../../../login/login.rest';
import { CustomersRest } from './../customers.rest';
import { CustomerRow } from './../customers.model'
import { GridSelection, SelectionMode, SortedColumn, GridMainFilter } from '../../../core/shared/grid/grid.model';
import { HasPermissions, Permissions } from '../../../core/services/permissions/permissions.model';
import { PermissionsService } from '../../../core/services/permissions/permissions.service';
import { SpinnerService } from '../../../core/services/spinner-handler/spinner-handler.service';
import { GridParamsRestoringService } from '../../../core/services/grid-params-restoring/grid-params-restoring.service';
import { GridParamsRestorable } from '../../../core/services/grid-params-restoring/grid-params-restoring.model';
import { MenuButton } from '../../../core/shared/tabmenu/tabmenu.model';

@Component({
  selector: 'app-customers-list',
  templateUrl: './customers-list.component.html',
  styleUrls: ['./customers-list.component.scss']
})
export class CustomersListComponent extends GridSelection implements OnInit, HasPermissions, AfterViewInit, GridParamsRestorable {
  readonly detailsPath: string = '/customers/customer';

  public permissions: Permissions;
  @Input() initialFilters: { code: '' };
  @ViewChild(GridComponent) grid: GridComponent;
  private path: string;
  public viewEnable = true;
  private isEditable: boolean;
  private isRemovable: boolean;
  private isAdd: boolean;
  public dialogConfigData: any;
  public initialPageNumber: number = 0;
  public initialPageSize: number;
  public editedItemId: number;
  public mainFilter: GridMainFilter[];
  public previousMainFilters: any = {};
  public initialSortedColumn: SortedColumn;
  public gridCustomButtons = [];
  public showArchived: boolean;
  private isRestoredMainFilter: boolean = false;
  public isDialog: boolean = false;

  private headers = [
    { displayName: 'Kod', propertyName: 'code', propertyType: 'string' },
    { displayName: 'Nazwa', propertyName: 'name', propertyType: 'string' },
    { displayName: 'NIP', propertyName: 'nip', propertyType: 'string' },
    { displayName: 'Stawka godzinowa', propertyName: 'hourlyRate', propertyType: 'number' },
    { displayName: 'Odległość od klienta', propertyName: 'distanceToCustomer', propertyType: 'number' },
    { displayName: 'Email', propertyName: 'email', propertyType: 'string', },
    { displayName: 'Telefon', propertyName: 'phone', propertyType: 'string' },
    { displayName: 'Adres', propertyName: 'address', propertyType: 'string' },
    { displayName: 'Regulamin', propertyName: 'rules', propertyType: 'bool' },
    { displayName: 'Zablokowany', propertyName: 'isBlocked', propertyType: 'bool' }
  ];

  private gridMenuButtons: MenuButton[] = [
    { text: 'Zablokuj kontrahenta', class: 'btn-danger', icon: '', onClick: () => { this.block(); }, enabled: false, isForSelected: true },
    { text: 'Odblokuj kontrahenta', class: "btn-warning", icon: '', onClick: () => { this.unblock(); }, enabled: false, isForSelected: true }
  ];

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private loginRest: LoginRest,
    private customerRest: CustomersRest,
    private permissionService: PermissionsService,
    private spinnerService: SpinnerService,
    private gridParamsRestoringService: GridParamsRestoringService
  ) {
    super();
    this._grid = this.grid;
    this.selectionMode = this.selectionMode === SelectionMode.none ? SelectionMode.multi : this.selectionMode;
  }


  ngOnInit() {
    this.spinnerService.show();
    this.setPermissions('Customer');
    this.mainFilter = new Array();
    this.processDialogConfig();
    this.path = 'api/customers/grid';
    if (!this.dialogConfigData) {
      this.isRestoredMainFilter = this.tryRestoreFiltersAndPage();
    }
  }

  ngAfterViewInit() {
    this.grid.mainFilter = this.mainFilter;
    this.spinnerService.hide();
  }

  setPermissions(claimType: string): void {
    this.permissions = this.permissionService.getUserPermissions(claimType);
    this.isEditable = !this.dialogConfigData && (this.permissions.canEdit || this.permissions.canShow);
    this.isRemovable = !this.dialogConfigData && this.permissions.canDelete;
    this.isAdd = !this.dialogConfigData && this.permissions.canAdd;
    this.gridMenuButtons.find(x => x.text === 'Zablokuj kontrahenta').enabled = this.permissions.hasCustomerBlockingPermission;
    this.gridMenuButtons.find(x => x.text === 'Odblokuj kontrahenta').enabled = this.permissions.hasCustomerBlockingPermission;
  }

  private processDialogConfig() {
    if(this.dialogConfigData != null){
      this.isDialog = this.dialogConfigData.selectList;
      this.grid.isModal = this.isDialog;
      if(this.dialogConfigData['initialFilters']){
        this.initialFilters = this.dialogConfigData['initialFilters'];
      }
    }
  }

  private onRowEdit(row: CustomerRow) {
    this.gridParamsRestoringService.saveCurrentGridParams(this.grid, row.id);
    this.router.navigate(['../customers/customer', row.name], { queryParams: { id: row.id }, relativeTo: this.route });
  }

  private onRowDelete(row: CustomerRow) {
    sweetAlert('Czy usunąć Kontrahenta?', {
      buttons: {
        yes: {
          text: 'Tak',
          value: 'yes'
        },
        no: {
          text: 'Nie',
          value: 'no',
        }
      }
    })
      .then((value) => {
        switch (value) {
          case 'yes':
            this.customerRest.removeCustomer(row.id).subscribe((result: string) => {
              if (result) {
                sweetAlert('Usunięto kontrahenta.');
                this.grid.refreshData(false);
              }
            });
            break;
        }
      });
  }

  public addCustomer() {
    this.gridParamsRestoringService.saveCurrentGridParams(this.grid);
    this.router.navigate(['../customers/customer', 'new'], { relativeTo: this.route });
  }

  private tryRestoreFiltersAndPage() : boolean {
    var previousGridParams = this.gridParamsRestoringService.getPreviousGridParams(this.detailsPath);
    if (!previousGridParams) {
      return;
    }

    this.initialFilters = previousGridParams.initialFilters;
    this.initialSortedColumn = previousGridParams.sortedColumn;
    this.initialPageNumber = previousGridParams.initialPageNumber;
    this.initialPageSize = previousGridParams.initialPageSize;
    this.editedItemId = previousGridParams.editedItemId;
    this.previousMainFilters = previousGridParams.previousMainFilters;

    return true;
  }

  private block() {
    var selectedItems = this.grid.getSelectedItems();
    if (selectedItems.length === 0) {
      sweetAlert('Nie zaznaczono elementu.');
      return;
    }
    if (selectedItems.length > 1) {
      sweetAlert('Zaznaczono więcej niż jeden element.');
      return;
    }
    var row = selectedItems[0];
    if (row.isBlocked) {
      sweetAlert(`Kontrahent ${row.name} jest już zablokowany.`);
      return;
    }
    sweetAlert('Czy na pewno chcesz zablokować Kontrahenta?', {
      buttons: {
        yes: {
          text: 'Tak',
          value: 'yes'
        },
        no: {
          text: 'Nie',
          value: 'no',
        }
      }
    })
      .then((value) => {
        switch (value) {
          case 'yes':
            this.customerRest.blockCustomer(row.id).subscribe((result: boolean) => {
              if (result) {
                sweetAlert('Zablokowano kontrahenta.');
                this.grid.refreshData(false);
              }
            });
            break;
        }
      });
  }

  private unblock() {
    var selectedItems = this.grid.getSelectedItems();
    if (selectedItems.length === 0) {
      sweetAlert('Nie zaznaczono elementu.');
      return;
    }
    if (selectedItems.length > 1) {
      sweetAlert('Zaznaczono więcej niż jeden element.');
      return;
    }
    var row = selectedItems[0];
    if (!row.isBlocked) {
      sweetAlert(`Kontrahent ${row.name} jest już odblokowany.`);
      return;
    }
    sweetAlert('Czy na pewno chcesz odblokować Kontrahenta?', {
      buttons: {
        yes: {
          text: 'Tak',
          value: 'yes'
        },
        no: {
          text: 'Nie',
          value: 'no',
        }
      }
    })
      .then((value) => {
        switch (value) {
          case 'yes':
            this.customerRest.unblockCustomer(row.id).subscribe((result: boolean) => {
              if (result) {
                sweetAlert('Odblokowano kontrahenta.');
                this.grid.refreshData(false);
              }
            });
            break;
        }
      });
  }

  public filter() {
    this.setFilter('ShowArchived', this.showArchived);

    this.grid.mainFilter = this.mainFilter;
    this.grid.refreshData();
  }

  public clearFilter() {
    this.mainFilter.forEach((item, index) => {
      if (item.internalName === 'ShowArchived') { this.mainFilter.splice(index, 1); }
    });

    this.grid.mainFilter = this.mainFilter;
    this.grid.refreshData();
    this.showArchived = false;
  }

  private setFilter(internalName: string, filterValue: any) {
    if (this.mainFilter != null) {
      this.mainFilter.forEach((item, index) => {
        if (item.internalName === internalName) { this.mainFilter.splice(index, 1); }
      });

      if (filterValue !== undefined) {
        this.mainFilter.push({ internalName: internalName, value: filterValue });
      }

      this.grid.mainFilter = this.mainFilter;
    }
  } 

  private setFiltersFromRestoredData() {
    const showArchived = this.findFilter('ShowArchived');
    console.log("CustomersListComponent -> setFiltersFromRestoredData -> showArchived", showArchived);
    if (showArchived != null && showArchived === 'true') {
      this.showArchived = true;
    } else if (showArchived != null && showArchived === 'false') {
      this.showArchived = false;
    } else {
      this.showArchived = this.showArchived;
    }
  }

  private findFilter(internalName: string): string {
    return this.grid.mainFilter.find(x => x.internalName === internalName) && this.grid.mainFilter.find(x => x.internalName === internalName).value || null;
  }
}
